import React, { useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useStoreModel } from "../storeModel";

export function BaseStore() {
    const {
        loadData,
        resetState,
        loadDs,
    } = useStoreModel()
    useEffect(() => {
        loadData({ pageNum: 1 }, {}).then()
        loadDs()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

